module.exports = __webpack_public_path__ + "img/ozo_logo_header.825e9471.svg";